import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EntranceLeaveTask } from '../../register-entrance-leave.model';

@Component({
    selector: 'app-tasks',
    templateUrl: './tasks.component.html',
    styleUrls: ['./tasks.component.scss'],
    standalone: false
})
export class TasksComponent {


  @Input() tasks: Array<EntranceLeaveTask>;

  @Input() transportId: number;

  @Output() changed = new EventEmitter<void>();

  handleTaskItemChanged($event: any) {
    this.changed.next();
  }
}
